import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { APPLY_USERINPUT_TYPES } from '@bingads-webui-campaign/recommendation-core';

import { GoalCreationEditor } from '../shared/goal-creation-editor';
import template from '../template/create-conversion-goal.pug';
import ViewModel from '../viewmodel/create-coversion-goal-model';

export default class CreateConversionGoalView extends Backbone.View {
  initialize({
    deps,
    data = {},
    i18n,
    newI18n,
    router,
    gridView,
    readOnly,
    isMCC,
    scope,
    gridService,
    permissions,
    perfMarker,
    serverContext,
    getGoalCreationRecommendationWizard,
    applyAction = null,
  }) {
    this.deps = deps;
    this.data = _.first(data.Opportunities);
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.router = router;
    this.ko_model = new ViewModel({ data, i18n, deps });
    this.grid = { gridView };
    this.readOnly = readOnly;
    this.isMCC = isMCC;
    this.scope = scope;
    this.gridService = gridService;
    this.permissions = permissions;
    this.perfMarker = perfMarker;
    this.serverContext = serverContext;
    this.getGoalCreationRecommendationWizard = getGoalCreationRecommendationWizard;
    this.goalData = this.getGoalData(this.data);
    this.isValid = true;
    this.isPanelEdit = true;
    this.applyAction = applyAction;
  }

  getGoalData(data) {
    let suggestedGoal;
    if (data.GoalTypeCode === 'DestinationGoal') {
      suggestedGoal = {
        UrlString: data.SuggestedGoal.DestinationUrl,
        Operator: data.SuggestedGoal.DestinationURLOperator,
      };
    } else if (data.GoalTypeCode === 'EventGoal') {
      suggestedGoal = data.SuggestedEventGoal;
    } else if (data.GoalTypeCode === 'ClarityEventGoal') {
      // convert event target array to object
      const eventTarget = {};
      _.each(data.SuggestedClarityEventGoal.ClarityEventInfo.Trigger.EventTarget, (value) => {
        eventTarget[value.Key] = value.Value;
      });
      suggestedGoal = {
        ...data.SuggestedClarityEventGoal,
        ClarityEventInfo: {
          ...data.SuggestedClarityEventGoal.ClarityEventInfo,
          Trigger: {
            ...data.SuggestedClarityEventGoal.ClarityEventInfo.Trigger,
            EventTarget: eventTarget,
          },
        },
      };
    }

    return {
      '@odata.type': '#Model.DestinationGoal',
      Name: data.GoalName,
      Type: data.GoalTypeCode,
      LookbackWindowInMinutes: data.LookbackWindowinMinutes,
      IsAccountLevel: data.IsAccountLevel,
      ConversionCountType: data.ConversionCountType,
      GoalValue: data.GoalValue,
      CurrencyCode: data.GoalValueCurrencyCode,
      GoalValueType: data.GoalValueType,
      IsMainConversionGoal: data.IsMainConversionGoal,
      ViewThroughLookbackWindowinMinutes: data.ViewThroughLookbackWindowinMinutesNullable,
      GoalCategory: data.GoalCategory,
      AttributionModelType: data.ConversionAttributionModelTypeStr,
      TagName: data.TagName,
      ...suggestedGoal,
    };
  }

  get events() {
    return {
      'click .btn-hero.apply': 'apply',
      'click .btn-cancel': 'closeInlineView',
    };
  }

  hasChanged() {
    return !_.isEqual(this.goalData, this.getGoalData(this.data));
  }

  apply() {
    // If the input values are not valid, the apply action is stopped.
    if (this.isValid === false) {
      return;
    }

    const { data, goalData } = this;
    const basicInput = {
      '@odata.type': APPLY_USERINPUT_TYPES[data.OpportunityType],
      OpportunityId: data.OpportunityId,
    };

    let suggestedGoal;
    let odataType;
    if (data.GoalTypeCode === 'DestinationGoal') {
      odataType = '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ConversionDestinationURLGoal';
      suggestedGoal = {
        DestinationUrl: goalData.UrlString,
        DestinationURLOperator: goalData.Operator,
      };
    } else if (data.GoalTypeCode === 'EventGoal') {
      odataType = '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ConversionEventGoal';
      suggestedGoal = {
        Category: goalData.Category,
        CategoryOperator: goalData.CategoryOperator,
        Action: goalData.Action,
        ActionOperator: goalData.ActionOperator,
        Label: goalData.Label,
        LabelOperator: goalData.LabelOperator,
        Value: goalData.Value,
        ValueOperator: goalData.ValueOperator,
      };
    } else if (data.GoalTypeCode === 'ClarityEventGoal') {
      // convert event target object to arrray
      const eventTarget = [];
      _.each(goalData.ClarityEventInfo.Trigger.EventTarget, (value, key) => {
        eventTarget.push({ Key: key, Value: value });
      });
      odataType = '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ConversionClarityEventGoal';
      suggestedGoal = {
        ClarityEventInfo: {
          ...goalData.ClarityEventInfo,
          Trigger: {
            ...goalData.ClarityEventInfo.Trigger,
            EventTarget: eventTarget,
          },
        },
        Category: goalData.Category,
        CategoryOperator: goalData.CategoryOperator,
        Action: goalData.Action,
        ActionOperator: goalData.ActionOperator,
        Label: goalData.Label,
        LabelOperator: goalData.LabelOperator,
        Value: goalData.Value,
        ValueOperator: goalData.ValueOperator,
      };
    }

    const userInput = {
      NewGoal: {
        '@odata.type': odataType,
        GoalName: goalData.Name,
        GoalType: goalData.Type,
        GoalValue: goalData.GoalValue,
        GoalValueType: goalData.GoalValueType,
        GoalValueCurrencyCode: goalData.CurrencyCode,
        IsAccountLevel: goalData.IsAccountLevel,
        LookbackWindowinMinutes: goalData.LookbackWindowInMinutes,
        IsMainConversionGoal: goalData.IsMainConversionGoal,
        ViewThroughLookbackWindowinMinutes: goalData.ViewThroughLookbackWindowinMinutes,
        GoalCategory: goalData.GoalCategory,
        ConversionCountType: goalData.ConversionCountType,
        SuggestedGoal: suggestedGoal,
        ConversionAttributionModelTypeStr: goalData.AttributionModelType,
      },
    };

    // Apply create conversion goal recommendation with user inputs
    if (this.isPanelEdit) {
      this.applyAction([this.data], [_.extend(basicInput, userInput)]);
    } else {
      this.trigger(
        'apply',
        {
          opportunities: [data],
          userInputs: [_.extend(basicInput, userInput)],
        }
      );
    }
  }

  exportUpdatedGoalObject = (updatedGoalObject, isValid) => {
    this.goalData = updatedGoalObject;
    this.isValid = isValid;
  };


  closeInlineView(e) {
    e.stopImmediatePropagation();
    this.remove();
    this.trigger('cancel');
  }

  removeElement = (container, name) => {
    if (!_.isNull(container.querySelector(name))) {
      container.querySelector(name).remove();
    }
  }

  render() {
    const {
      serverContext,
      permissions,
      perfMarker,
      i18n,
      newI18n,
      data,
      goalData,
      getGoalCreationRecommendationWizard,
      readOnly,
    } = this;
    const { instrumentation } = this.deps;

    const memo = newI18n.getString(_TL_('You can change the UET tag and goal category on the Create conversion goal page.'));
    const uetTitle = newI18n.getString(_TL_('UET tag'));
    const categoryTitle = newI18n.getString(_TL_('Goal category'));
    const params = _.extend(this.ko_model, {
      i18n,
      memo,
      uetTitle,
      categoryTitle,
      data,
      readOnly,
      isPanelEdit: this.isPanelEdit,
    });
    this.$el.html($(template(params)));

    ko.applyBindings(this.ko_model, this.$el[0]);
    this.delegateEvents();

    const scope = _.extend({}, this.scope, {
      values: {
        aid: this.scope.accountId,
        cid: this.scope.customerId,
        uid: this.scope.userId,
      },
    });

    const container = this.$el[0].querySelector('.create-conversion-goal-edit-content');
    ReactDOM.render(
      (
        <InstrumentationContext.Provider value={instrumentation}>
          <I18nContext.Provider value={newI18n}>
            <GoalCreationEditor
              permissions={permissions}
              serverContext={serverContext}
              scope={scope}
              perfMarker={perfMarker}
              goalData={goalData}
              isDemo={false}
              getGoalCreationRecommendationWizard={getGoalCreationRecommendationWizard}
              exportUpdatedGoalObject={this.exportUpdatedGoalObject}
            />
          </I18nContext.Provider>
        </InstrumentationContext.Provider>
      ), container
    );

    // Remove some goal create wizard elements which are not included in editor page.
    this.removeElement(container, '.step-header');
    this.removeElement(container, '[class*=\'SpecificGoalSettingsViewUnstyled-defaultTitle\']');
    this.removeElement(container, '.conversion-wizard-footer');

    return this;
  }
}
